// Polling delay in seconds for retrieving latest order status when on first step
export const ORDER_STATUS_FIRST_STEP_POLL_DELAY = 10000;

// Polling delay in seconds for retrieving latest order status when on remaining steps
export const ORDER_STATUS_POLL_DELAY = 60000;
